<section class="cz-recommendations-configuration-category-dialog-component">
  <mat-dialog-title class="mat-dialog-title">
    <div class="row">
      <div class="col-xs-9">
        <h3 class="title" *ngIf="addNewCategory" [innerHTML]="_defaultStrings?.defaultStringArray?.$common_add_categories | translate"></h3>
        <h3 class="title" *ngIf="!addNewCategory" [innerHTML]="_defaultStrings?.defaultStringArray?.$common_edit_category | translate"></h3>
      </div>
      <div class="col-xs-3 end-xs">
        <button mat-button mat-dialog-close class="mat-dialog-back-button">
            <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>
  </mat-dialog-title>
  <mat-dialog-content>
    <div class="col-xs-12 end-xs" *ngIf="!addNewCategory && this.supportedlanguage.length>1">
      <button mat-button (click)="openAll()" *ngIf="!panelOpenState"
        [innerHTML]="_defaultStrings?.defaultStringArray?.$btn_expand_all | translate"></button>
      <button mat-button (click)="closeAll()" *ngIf="panelOpenState"
        [innerHTML]="_defaultStrings?.defaultStringArray?.$btn_collapse_all | translate"></button>
    </div>
    <p *ngIf="addNewCategory" [innerHTML]="_defaultStrings?.defaultStringArray?.$common_add_category_trans_desc | translate"></p>
    <p *ngIf="addNewCategory" [innerHTML]="_defaultStrings?.defaultStringArray?.$recommendation_config_categories_desc | translate"></p>
    
    <form [formGroup]="addNewCategoryForm" #formDirective="ngForm" (ngSubmit)="resetAddNewCategoryForm(formDirective)">
      <p *ngIf="addNewCategory || this.supportedlanguage.length===1">
        <mat-form-field class="form-full-width-field form-field">
          <input matInput placeholder="{{_defaultStrings?.defaultStringArray?.$common_enter_category | translate}}" required
            formControlName="categoryTitleControl" (keyup.enter)="saveCategory()" />
          <span class="searchhiddenToolTip">
            <mat-icon class="link" *ngIf="addNewCategory" matSuffix (click)="saveCategory()">add_circle</mat-icon>
            <span class="search-download-tool-tip"
              [innerHTML]="_defaultStrings?.defaultStringArray?.$common_circleplus_hover | translate"></span>
          </span>
        </mat-form-field>
      </p>
    </form>
    
    <mat-accordion #recommendationCategoryItemsAccordion="matAccordion"  multi="true"  class="training-review-panels"  *ngIf="!addNewCategory && this.supportedlanguage.length>1">
          <mat-expansion-panel [expanded]="panelOpenState"  *ngFor="let row of addForm.get('rows')?.controls;let index = index;" ><!-- *ngFor="let list of supportedlanguage" -->
            <mat-expansion-panel-header>
              <mat-panel-title class="truncate">{{getLanguageeName(row.get('languageId').value)}}<span *ngIf="defaultLanguage === row.get('languageId').value">*</span>
              </mat-panel-title>
            </mat-expansion-panel-header>

            <mat-form-field *ngIf="!addNewCategory" class="invisible example-full-width" >
              <input matInput required [formControl]="row.get('languageId')"  />
            </mat-form-field>

            <mat-form-field *ngIf="!addNewCategory" class="form-full-width-field form-field">
              <input matInput placeholder="{{_defaultStrings?.defaultStringArray?.$common_category_name | translate}}" required
                [formControl]="row.get('title')" (keyup)="isDefaultInput()" />
            </mat-form-field>
          </mat-expansion-panel>
        </mat-accordion>
  </mat-dialog-content>
  <mat-actions>
    <div class="row">
      <div class="col-xs">
        <!-- Only show Delete if no recommended items for this category exist -->
        <button *ngIf="!addNewCategory && !itemsExist" mat-button color="error" class="btn-delete" mat-dialog-close [innerHTML]="_defaultStrings?.defaultStringArray?.$btn_delete | translate"></button>
        <button *ngIf="!addNewCategory && itemsExist" mat-stroked-button color="accent" mat-dialog-close [innerHTML]="_defaultStrings?.defaultStringArray?.$btn_cancel | translate"></button>
      </div>
      <div class="col-xs end-xs">
        <button *ngIf="addNewCategory" mat-flat-button color="accent" mat-dialog-close [innerHTML]="_defaultStrings?.defaultStringArray?.$btn_close | translate"></button>
        <button *ngIf="!addNewCategory && !itemsExist" class="btn-cancel-alt" mat-stroked-button color="accent" mat-dialog-close [innerHTML]="_defaultStrings?.defaultStringArray?.$btn_cancel | translate"></button>
        

        <button *ngIf="!addNewCategory" [disabled]="isButtonDisabled" mat-flat-button color="accent" mat-dialog-close
          [innerHTML]="_defaultStrings?.defaultStringArray?.$btn_save | translate" (click)="saveCategory()"></button>
      </div>
    </div>
  </mat-actions>
</section>